import { Link } from 'react-router-dom';
import { Shield, Users, Award, MapPin, Phone } from 'lucide-react';
import { COMPANY_INFO } from '../data/siteData';

export default function About() {
  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="relative h-[350px] lg:h-[400px]">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://customer-assets.emergentagent.com/job_pressure-wash-demo-1/artifacts/p0lku1jo_Eddy%20on%20Metal%20Roof%201.jpg')`,
          }}
        />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-end pb-12">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky-200 mb-3">Our Story</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight font-black text-white">
            About Us
          </h1>
        </div>
      </section>

      {/* About content */}
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky-700 mb-3">Who We Are</p>
              <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-slate-900 mb-6">
                {COMPANY_INFO.name}
              </h2>
              <p className="text-slate-600 text-base leading-relaxed mb-6">
                {COMPANY_INFO.about}
              </p>
              <p className="text-slate-600 text-base leading-relaxed mb-6">
                With years of experience serving Southwest Florida, we understand the unique challenges that the tropical climate presents to property owners. From algae-covered roofs to mildew-stained driveways, we've seen it all — and we know exactly how to handle it.
              </p>
              <p className="text-slate-600 text-base leading-relaxed">
                Our commitment to quality work, fair pricing, and outstanding customer service has made us one of the most trusted names in pressure washing throughout the region. We treat every property as if it were our own.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-sky-50 rounded-2xl p-6 text-center border border-sky-100">
                <div className="w-12 h-12 bg-sky-700 rounded-2xl flex items-center justify-center mx-auto mb-3">
                  <Shield className="w-6 h-6 text-white" />
                </div>
                <h4 className="font-heading font-semibold text-slate-900 mb-1">Licensed & Insured</h4>
                <p className="text-slate-500 text-xs">Full coverage for your protection</p>
              </div>
              <div className="bg-sky-50 rounded-2xl p-6 text-center border border-sky-100">
                <div className="w-12 h-12 bg-sky-700 rounded-2xl flex items-center justify-center mx-auto mb-3">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <h4 className="font-heading font-semibold text-slate-900 mb-1">Expert Team</h4>
                <p className="text-slate-500 text-xs">Trained professionals on every job</p>
              </div>
              <div className="bg-sky-50 rounded-2xl p-6 text-center border border-sky-100">
                <div className="w-12 h-12 bg-sky-700 rounded-2xl flex items-center justify-center mx-auto mb-3">
                  <Award className="w-6 h-6 text-white" />
                </div>
                <h4 className="font-heading font-semibold text-slate-900 mb-1">Quality Results</h4>
                <p className="text-slate-500 text-xs">Satisfaction guaranteed always</p>
              </div>
              <div className="bg-sky-50 rounded-2xl p-6 text-center border border-sky-100">
                <div className="w-12 h-12 bg-sky-700 rounded-2xl flex items-center justify-center mx-auto mb-3">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <h4 className="font-heading font-semibold text-slate-900 mb-1">Locally Owned</h4>
                <p className="text-slate-500 text-xs">Proudly serving SW Florida</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-sky-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-white mb-4">
            Let's Get Started
          </h2>
          <p className="text-sky-200 mb-6 max-w-md mx-auto">
            Contact us today for a free, no-obligation estimate on any of our services.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              data-testid="about-cta-btn"
              className="bg-white text-sky-700 font-semibold rounded-full px-8 py-3 hover:bg-sky-50 transition-colors"
            >
              Get a Free Estimate
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
